import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { cognitoTokenService } from "../shared/cognitoTokenService.service";

@Injectable({
    providedIn: 'root'
})

export class FormService {
    private apiUrl = environment.apiUrl;
    
    constructor(private httpClient: HttpClient, private tokenService: cognitoTokenService) { }
  
    /**
     * Sends form.
     */
    public sendForm(body: any): Observable<any[]> {
      return from(this.tokenService.getToken()).pipe(
        switchMap(token => {   
          const headers = new HttpHeaders({
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          });
    
          return this.httpClient.post<any>(this.apiUrl, body, { headers });
        })
      );
    }
}